var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.213,
    height: 22.097,
    viewBox: "0 0 16.213 22.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_400",
    "data-name": "Rectangle 400",
    width: 16.213,
    height: 22.097,
    fill: "#0862d9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M15.246,3.931,11.627.718A2.91,2.91,0,0,0,9.731,0H2.854A2.856,2.856,0,0,0,0,2.854V19.243A2.857,2.857,0,0,0,2.854,22.1h10.5a2.856,2.856,0,0,0,2.854-2.854V6.068a2.851,2.851,0,0,0-.967-2.136Zm-3.194,15.4H4.161a1.4,1.4,0,0,1-1.4-1.4V12.117a1.405,1.405,0,0,1,1.4-1.4h7.88a1.4,1.4,0,0,1,1.391,1.4l.018,5.818A1.4,1.4,0,0,1,12.051,19.335Z",
    transform: "translate(0 0)",
    fill: "#0862d9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveIcon);
export default __webpack_public_path__ + "static/media/active-icon.a61a50e7164303b56f77b2435af8a4ed.svg";
export { ForwardRef as ReactComponent };